export const getImage = (diretorio) => {
  if(typeof diretorio !== "string") return "";
  
  const array = diretorio.split('/')
  const img =  array[array.length - 1]
  return  process.env.REACT_APP_API_BASE_URL + `/api/pontuacoes/foto/${img}` 
}